/**
 * @fileoverview Admin Route Guard
 * 
 * Protects admin routes by checking user's admin role.
 * Redirects non-admins to app home.
 */

import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { BrandedLoader } from '@/components/ui/BrandedLoader';

interface AdminGuardProps {
  children: React.ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const { isAdmin, isLoading, user } = useAdminAuth();

  if (isLoading) {
    return <BrandedLoader fullPage />;
  }

  if (!user) {
    return <Navigate to="/app" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
